var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpendCategoryIncome32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DDL-CBA---Icons-Mobile",
    transform: "translate(-1230.000000, -796.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon//SpendCategory/Income32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding-box",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogram",
    transform: "translate(3.000000, 4.000000)",
    fill: "#706D6E"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.77975432,1.26841999 L4.31086746,2.72044935 L1.54894348,6.52191158 L1.54894348,11.2207773 L4.31086746,15.0222395 C5.06817659,14.1934995 5.69660977,13.6458438 6.19616699,13.3792725 C6.69572422,13.1127011 7.55692,12.865468 8.77975432,12.6375732 C10.2555618,12.8423234 11.2649308,13.0895564 11.8078613,13.3792725 C12.3507919,13.6689885 12.8310518,14.2166442 13.2486412,15.0222395 L13,12 L16.0105652,8.57165527 L16.0105652,6.52191158 L13.2486412,2.72044935 L8.77975432,1.26841999 Z M13.8666752,1.86979855 L17.0105652,6.19699188 L17.0105652,8.50170898 L14.1027832,10.9675293 C13.532888,11.9665507 13.2343854,12.7476786 13.2072754,13.3109131 C13.1801654,13.8741476 13.3999654,14.72814 13.8666752,15.8728903 C12.98545,14.8701377 12.2078294,14.1873285 11.5338135,13.8244629 C10.8597975,13.4615972 9.94177781,13.2315354 8.77975432,13.1342773 C7.86253188,13.2378614 7.07278792,13.4679233 6.41052246,13.8244629 C5.748257,14.1810025 4.84236067,14.8638117 3.69283347,15.8728903 L0.548943484,11.545697 L0.548943484,6.19699188 L3.69283347,1.86979855 L8.77975432,0.216957767 L13.8666752,1.86979855 Z",
    id: "50c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "$",
    transform: "translate(7.000000, 15.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,6.07142857 L0.5,5.07142857 L2.21518009,5.07142857 L2.21518009,6.07142857 L0.5,6.07142857 Z M2,2.92857143 L2,3.92857143 L1.57142857,3.92857143 L1.57142857,2.92857143 L2,2.92857143 Z M1.5,1.78571429 L1.5,0.785714286 L3.1,0.785714286 L3.1,1.78571429 L1.5,1.78571429 Z",
    id: "Arms"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.57142857,0.785714286 L1.57142857,1.78571429 C1.25583729,1.78571429 1,2.04155157 1,2.35714286 C1,2.67273414 1.25583729,2.92857143 1.57142857,2.92857143 L1.57142857,3.92857143 C0.703552536,3.92857143 0,3.22501889 0,2.35714286 C0,1.48926682 0.703552536,0.785714286 1.57142857,0.785714286 Z",
    id: "Curve"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57142857,2.92857143 L3.57142857,3.92857143 C3.25583729,3.92857143 3,4.18440871 3,4.5 C3,4.81559129 3.25583729,5.07142857 3.57142857,5.07142857 L3.57142857,6.07142857 C2.70355254,6.07142857 2,5.36787604 2,4.5 C2,3.63212396 2.70355254,2.92857143 3.57142857,2.92857143 Z",
    id: "Curve-bottom",
    transform: "translate(2.785714, 4.500000) scale(-1, 1) translate(-2.785714, -4.500000) "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stick-top",
    points: "2.5 1.28571429 1.5 1.28571429 1.5 0 2.5 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stick-bottom",
    points: "2.5 6.85714286 1.5 6.85714286 1.5 5.57142857 2.5 5.57142857"
  })), /*#__PURE__*/React.createElement("g", {
    id: "dollar",
    transform: "translate(2.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,18.5 C3.41014913,18.5 0.5,15.5898509 0.5,12 C0.5,8.41014913 3.41014913,5.5 7,5.5 C10.5898509,5.5 13.5,8.41014913 13.5,12 C13.5,15.5898509 10.5898509,18.5 7,18.5 Z M7,17.5 C10.0375661,17.5 12.5,15.0375661 12.5,12 C12.5,8.96243388 10.0375661,6.5 7,6.5 C3.96243388,6.5 1.5,8.96243388 1.5,12 C1.5,15.0375661 3.96243388,17.5 7,17.5 Z",
    id: "Focus"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,14.5 C15.9154721,14.5 14.453909,13.9735253 13.2806944,13.0859597 C12.7277113,12.6676143 13.0162346,12.4195355 12.8988647,12.1514893 C12.6576958,11.600714 12.5128174,11.069953 12.5128174,9.53533936 C12.5128174,9.23340414 10.5191164,6.90059444 10.5562048,6.60873324 C10.9939986,3.16358941 13.935942,0.5 17.5,0.5 C21.3659932,0.5 24.5,3.63400675 24.5,7.5 C24.5,11.3659932 21.3659932,14.5 17.5,14.5 Z M17.5,13.5 C20.8137085,13.5 23.5,10.8137085 23.5,7.5 C23.5,4.1862915 20.8137085,1.5 17.5,1.5 C14.1862915,1.5 11.5,4.1862915 11.5,7.5 C11.5,8.53584294 12.043707,8.3173243 12.5057983,9.16766357 C12.7301705,9.58055259 12.7203848,11.1572142 13.0316764,11.5043414 C14.1301945,12.7293199 15.7250962,13.5 17.5,13.5 Z",
    id: "Focus-Copy"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpendCategoryIncome32);
export default __webpack_public_path__ + "static/media/spendCategoryIncome32.8c36c1884e7761124a5ff48d52550398.svg";
export { ForwardRef as ReactComponent };